module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-images-wrapper"
  }, [_c('div', {
    staticClass: "close-modal p-2 float-right"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": _vm.closeProdMZoomModal
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0z",
      "transform": "translate(-1 1) translate(1 -1)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "rgba(0,0,0,0.5)",
      "stroke": "rgba(255,255,255,0.6)",
      "d": "M12 2a10 10 0 1 0 10 10A9.991 9.991 0 0 0 12 2z",
      "transform": "translate(-1 1) translate(1 -1)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M16.237 8L13 11.238 9.762 8 8 9.762 11.238 13 8 16.237 9.762 18 13 14.763 16.237 18 18 16.237 14.763 13 18 9.762z",
      "transform": "translate(-1 1) translate(0 -2)"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "zoom-parent"
  }, [(_vm.videoUrl && _vm.isVideoActive === 1 && (_vm.currImage === _vm.videoIndex - 1 || _vm.videoIndex === 0)) ? _c('div', {
    staticClass: "video-show",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd
    }
  }, [_c('VideoPlayer', {
    attrs: {
      "src": _vm.videoUrl,
      "poster": _vm.getActiveImage,
      "playVideo": _vm.playVideo
    }
  })], 1) : _c('div', {
    staticClass: "productZoomer",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove,
      "touchend": _vm.handleTouchEnd
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getActiveImage
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "imgList-wrap ml-2 mr-2 d-flex flex-row"
  }, [_c('carousel', {
    ref: "my-carousel",
    staticClass: "bannerview",
    attrs: {
      "paginationEnabled": false,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "paginationPadding": 7,
      "perPageCustom": [
        [480, 2],
        [768, 4],
        [1200, 5],
        [1920, 6]
      ],
      "perPage": 4,
      "navigateTo": _vm.navShown ? _vm.getcurrPage : 0
    }
  }, _vm._l((_vm.getImageArray), function(prm, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "card-container pointer m-1'"
    }, [_c('img', {
      staticClass: "img-card",
      class: index !== _vm.currImage ? 'p-3' : 'p-2',
      attrs: {
        "data-src": prm
      },
      on: {
        "click": function($event) {
          _vm.switchImage(index)
        }
      }
    }), _vm._v(" "), (_vm.videoUrl && _vm.isVideoActive === 1 && (index === _vm.videoIndex - 1 || _vm.videoIndex === 0)) ? _c('div', {
      staticClass: "overlay",
      on: {
        "click": function($event) {
          _vm.switchImage(index)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "height": "20px"
      },
      attrs: {
        "src": "https://tss-static-images.gumlet.io/media/play.png"
      }
    })]) : _vm._e()])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78622346"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/productZoomModal.vue
// module id = 2552
// module chunks = 13